import type { z } from "astro:content";

import type {
  GameSettings,
  GameSettingsSchema,
} from "~/components/GameSettings";

import { useSearchParam } from "./url";

const useGameSettingSearchParam = (
  param: keyof z.infer<typeof GameSettingsSchema>,
  isEnabled: boolean,
) => {
  useSearchParam(param, isEnabled.toString());
};

export const useGameSettings = (settings: GameSettings) => {
  useGameSettingSearchParam("first_letter", settings.isFirstLetterShown);
  useGameSettingSearchParam("typing_feedback", settings.isTypingFeedbackShown);
  useGameSettingSearchParam("hint", settings.isHintEnabled);
  useGameSettingSearchParam("time_rewards", settings.isTimeRewardEnabled);
};
